import { type FC } from 'react';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';

import styles from './PhotoModalCloseButton.scss';

type Props = {
    onClick: () => void;
};

const PhotoModalCloseButton: FC<Props> = ({ onClick }) => {
    return <ModalCloseButton className={styles.button} onClick={onClick} />;
};

export default PhotoModalCloseButton;
